{
    "locale": "nl-NL",
    "error": {
        "unsupportedMethod": "Niet-ondersteunde methode: {method}"
    },
    "account": {
        "deleteTokenTooltip": "Token onherroepelijk verwijderen?",
        "deleteToken": "Token verwijderen",
        "apiAccountToken": "API-accounttoken",
        "createApiToken": "Nieuwe API-accounttoken aanmaken",
        "createToken": "Token aanmaken",
        "existingTokens": "Bestaande tokens",
        "noApiTokensCreated": "Er zijn nog geen API-accounttokens aangemaakt.",
        "description": "Beschrijving",
        "createdOn": "Aangemaakt op",
        "token": "Token",
        "saveTokenWarning": "Bewaar deze token goed, deze wordt niet opnieuw getoond.",
        "hint": "Tip",
        "tokenCopiedNotification": "Token is gekopieerd naar het klembord.",
        "registrationNotice": "Let op: eInfo-registratie werkt alleen als u al een geregistreerde handelaar bent.",
        "registrationDescription": "Door u hier te registreren krijgt u niet alleen toegang tot onze shop, maar ook tot ons kennisplatform eInfo:",
        "informationAvailableTitle": "Altijd en overal informatie beschikbaar",
        "statusQuery": "Statusaanvraag van offertes en orders",
        "downloadDocuments": "Download van offerte, orderbevestiging en factuur",
        "downloadImages": "Download van 2D- en 3D-afbeeldingen en DXF-bestanden",
        "tracking": "Zending volgen",
        "customerLink": "Informeer klanten en verwerkers via link over de status",
        "recognizeChargeable": "Betaalbare processen direct herkennen",
        "viewInvoices": "Verzonden facturen per order bekijken",
        "andMore": "En meer",
        "oneClickSolutionTitle": "Met één klik een oplossing",
        "inquiryExample": "Vraag stellen (bijv. bij offertewijziging)",
        "requestManual": "Montagehandleiding aanvragen",
        "registerNow": "Nu gratis registreren:",
        "requestAccess": "Toegang aanvragen",
        "companyData": "Bedrijfsgegevens",
        "customerNumber": "Klantnummer",
        "company": "Bedrijf",
        "streetAndHouseNumber": "Straat en huisnummer",
        "postcode": "Postcode",
        "city": "Plaats",
        "country": "Land",
        "personalAccess": "Persoonlijke toegang",
        "salutation": "Aanhef",
        "firstName": "Voornaam",
        "lastName": "Achternaam",
        "position": "Functie",
        "email": "E-mail",
        "phone": "Telefoon",
        "mobilePhone": "Mobiele telefoon",
        "fax": "Fax",
        "user": "Gebruiker",
        "termsAcceptance": "Ik heb de",
        "termsAndConditions": "Gebruiksvoorwaarden",
        "privacyPolicy": "Privacyverklaring",
        "submitRequest": "Aanvraag versturen",
        "acknowledged": "kennisgenomen en geaccepteerd",
        "requestForwarded": "De aanvraag is doorgestuurd.",
        "resetPassword": "Wachtwoord opnieuw instellen",
        "passwordMismatch": "Het wachtwoord komt niet overeen met de herhaling!",
        "passwordComplexity": "Het wachtwoord voldoet niet aan de complexiteitsvereisten. Gebruik een combinatie van hoofdletters, kleine letters, cijfers en speciale tekens, met minimaal 8 tekens.",
        "passwordSetSuccess": "Uw wachtwoord is ingesteld. U kunt nu inloggen met uw toegangsgegevens.",
        "passwordChangeSuccess": "Uw wachtwoord is gewijzigd.",
        "errorOccurred": "Er is een fout opgetreden. Probeer het later opnieuw.",
        "passwordResetLinkSent": "Als er een toegang bestaat voor de opgegeven gebruikersnaam, is er een link naar het opgegeven e-mailadres gestuurd om het wachtwoord opnieuw in te stellen.",
        "setPasswordTitle": "Wachtwoord instellen",
        "setPasswordDescription": "Stel hier een nieuw wachtwoord in voor uw toegang. U kunt daarna direct inloggen met uw gebruikersnaam en dit wachtwoord.",
        "changePasswordTitle": "Wachtwoord wijzigen",
        "newPasswordPlaceholder": "nieuw wachtwoord",
        "repeatPasswordPlaceholder": "wachtwoord herhalen",
        "termsAndConditionsRead1": "Ik heb de",
        "termsAndConditionsRead2": "kennisgenomen en geaccepteerd",
        "submitButton": "versturen",
        "accessDenied": "Toegang geweigerd!",
        "closeInfo": "Uw wijzigingsverzoeken worden gecontroleerd.",
        "unlockColleague": "Collega ontgrendelen",
        "sendChanges": "Wijzigingsverzoek versturen",
        "firstname": "Voornaam",
        "lastname": "Achternaam",
        "submitChangeRequest": "Wijzigingsverzoek versturen",
        "accessNumber": "Toegangsnummer",
        "changeRequestInProgress": "Uw wijzigingsverzoeken worden gecontroleerd.",
        "iAccept": "Ik heb de",
        "haveRead": "kennisgenomen",
        "request": "aanvragen",
        "customerBase": "Klantbestand",
        "documentationHTML": "<h2>Documentatie</h2><p>Hoe u de API kunt gebruiken, vindt u in onze <a href=\"{frontendBase}/tibi-api/_/{namespace}/_/assets/redoc/\" target=\"_blank\">API-documentatie</a>.</p><p>De API is een REST-API die u kunt aanspreken met elke HTTP-client.</p><p>Voor authenticatie moet u de gegenereerde token toevoegen aan de HTTP-header \"account-token-v1\".</p><h3>Voorbeeld</h3><p><code>curl 'https://einfo.renzgroup.com/api/operation?limit=10&offset=0&sort=-insertTime'<br />&nbsp; -H \"accept: application/json\"<br />&nbsp; -H \"account-token-v1: TOKEN\"</code></p>"
    },
    "header": {
        "watchlist": "Verlanglijst",
        "processInformationSystem": "Procesinformatiesysteem",
        "switchAccount": "Account wisselen",
        "changeMasterData": "Stamgegevens wijzigen",
        "changePassword": "Wachtwoord wijzigen",
        "template": "Sjabloon",
        "priceCalculation": "Prijsberekening",
        "addressBook": "Adresboek",
        "integrations": "Integraties",
        "token": "Token",
        "logout": "Afmelden",
        "login": "Aanmelden",
        "more": "Meer",
        "copyrightPage": "Colofon",
        "logoutIn": "afmelden over {logoutInMinutes} min"
    },
    "notifications": {
        "successfulLogout": "U bent succesvol afgemeld.",
        "failedLogout": "Er is een fout opgetreden bij het aanmelden. Controleer uw toegangsgegevens.",
        "resubmissionSuccessfullyUpdated": "Herinnering succesvol bijgewerkt.",
        "resubmissionSuccessfullyCreated": "Herinnering succesvol aangemaakt.",
        "changesGotSaved": "De wijzigingen zijn succesvol opgeslagen."
    },
    "cart": {
        "cancel": "annuleren",
        "moveToCart": "naar winkelwagen verplaatsen",
        "move": "verplaatsen",
        "referenceOfferNotFound": "Referentieaanbieding niet gevonden",
        "mapping": {
            "refNumber": "Referentienummer",
            "number": "Nummer",
            "endCustomerEmail": "Eindklant E-mail",
            "endCustomerPhone": "Eindklant Telefoon",
            "endCustomerAddress": {
                "label": "Adres eindklant",
                "name1": "Naam 1",
                "name2": "Naam 2",
                "name3": "Naam 3",
                "street": "Straat",
                "country": "Land",
                "postcode": "Postcode",
                "city": "Plaats"
            },
            "endCustomerVAT": "Eindklant btw",
            "sumEndCustomerPrice": "Prijs voor eindklant",
            "sumEndCustomerPriceGross": "Prijs voor eindklant incl. btw",
            "type": {
                "label": "Type",
                "1": "Aanbieding",
                "2": "Order"
            },
            "source": {
                "label": "Bron",
                "10": "Backoffice",
                "20": "eConfig Pro (RIK)",
                "30": "eConfig (VR)",
                "31": "eAssist",
                "40": "RIT",
                "50": "eShop",
                "60": "eInfo",
                "80": "VU verbonden bedrijven",
                "90": "LIK"
            },
            "statusSummary": {
                "label": "Statusoverzicht",
                "created": {
                    "label": "Aangemaakt",
                    "0": "nee",
                    "30": "in behandeling",
                    "100": "afgerond"
                },
                "emailed": {
                    "label": "Verzonden",
                    "0": "nee",
                    "100": "ja"
                }
            },
            "orderedSummary": {
                "label": "Besteloverzicht",
                "ordered": {
                    "label": "Besteld",
                    "0": "nee",
                    "100": "ja"
                },
                "orderedCount": "Aantal besteld"
            },
            "endCustomerFullAddress": {
                "label": "Volledig adres eindklant",
                "id": "ID",
                "insertTime": "Invoertijd",
                "updateTime": "Bijwerktijd",
                "dealerNumber": "Dealernummer",
                "type": {
                    "label": "Type",
                    "person": "Persoon",
                    "company": "Bedrijf"
                },
                "vat": "Btw",
                "company": {
                    "label": "Bedrijf",
                    "name": "Naam",
                    "vatId": "Btw-nummer",
                    "firstname": "Voornaam",
                    "lastname": "Achternaam",
                    "paymentTerms": "Betaalvoorwaarden"
                },
                "person": {
                    "label": "Persoon",
                    "salutation": "Aanhef",
                    "firstname": "Voornaam",
                    "lastname": "Achternaam",
                    "parentCompany": "Moederbedrijf"
                },
                "location": {
                    "label": "Locatie",
                    "street": "Straat",
                    "houseNumber": "Huisnummer",
                    "supplement": "Aanvulling",
                    "postcode": "Postcode",
                    "city": "Plaats",
                    "country": "Land"
                },
                "contact": {
                    "label": "Contact",
                    "phone": "Telefoon",
                    "fax": "Fax",
                    "email": "E-mail",
                    "website": "Website"
                },
                "customerNumber": "Klantnummer",
                "priceCalculation": "Prijsberekening",
                "notModifyablePCalc": "Niet wijzigbare prijsberekening",
                "deliveryAddress": {
                    "label": "Leveringsadres",
                    "salutation": "Aanhef",
                    "name1": "Naam 1",
                    "name2": "Naam 2",
                    "name3": "Naam 3",
                    "street": "Straat",
                    "country": "Land",
                    "postcode": "Postcode",
                    "city": "Plaats",
                    "phone": "Telefoon",
                    "fax": "Fax",
                    "email": "E-mail"
                }
            },
            "dealerNumber": "Dealernummer",
            "inquiryDate": "Aanvraagdatum",
            "inquiryNumber": "Aanvraagnummer",
            "receiptDate": "Ontvangstdatum",
            "releaseDate": "Vrijgavedatum",
            "constructionProject": "Bouwproject",
            "constructionSite": "Bouwplaats",
            "commission": "Commissie",
            "residentialUnitsCount": "Aantal wooneenheden",
            "deliveryAddress": {
                "label": "Leveringsadres",
                "salutation": "Aanhef",
                "name1": "Naam 1",
                "name2": "Naam 2",
                "name3": "Naam 3",
                "street": "Straat",
                "country": "Land",
                "postcode": "Postcode",
                "city": "Plaats",
                "phone": "Telefoon",
                "fax": "Fax",
                "email": "E-mail"
            },
            "inquiryContact": {
                "label": "Verantwoordelijke / Besteller",
                "name": "Naam"
            },
            "endCustomer": {
                "label": "Eindklant",
                "name": "Naam"
            },
            "sumNetPrice": "Netto prijs",
            "sumRetailPrice": "Adviesprijs",
            "clerk": {
                "label": "Verantwoordelijke",
                "name": "Naam",
                "email": "E-mail"
            },
            "internalClerk": {
                "label": "Interne verantwoordelijke",
                "name": "Naam"
            },
            "additionalPositions": {
                "label": "Extra posities",
                "number": "Nummer",
                "service": "Dienst",
                "description": "Beschrijving",
                "netPrice": "Netto prijs",
                "amount": "Aantal"
            },
            "documentTemplateTextContent": {
                "label": "Sjabloon tekstinhoud",
                "emailSubject": "E-mail onderwerp",
                "emailBody": "E-mailtekst",
                "pdfIntro": "PDF inleiding",
                "pdfOutro": "PDF afsluiting",
                "preLetter": "Voorbrief",
                "deliveryTime": "Levertijd",
                "paymentTerms": "Betaalvoorwaarden",
                "contact": {
                    "label": "Contact",
                    "useLoggedInUserAsDefault": "Gebruik ingelogde gebruiker als standaard",
                    "name": "Naam",
                    "phone": "Telefoon",
                    "email": "E-mail",
                    "webUrl": "Website"
                }
            }
        },
        "positions": {
            "label": "Posities",
            "number": "Nummer",
            "type": "Type",
            "quantity": "Aantal",
            "orderQuantity": "Aantal in bestelling",
            "color": {
                "label": "Kleur",
                "code": "Kleurcode",
                "name": "Kleurnaam"
            },
            "additionalItems": {
                "label": "Extra artikelen",
                "number": "Nummer",
                "description": "Beschrijving",
                "netPrice": "Nettoprijs",
                "service": "Dienst",
                "amount": "Hoeveelheid"
            },
            "state": {
                "label": "Status",
                "code": "Code",
                "description": "Beschrijving",
                "blockingIndicator": "Blokkeringskenmerk"
            },
            "delivery": {
                "label": "Levering",
                "plannedDate": "geplande datum",
                "plannedDateNew": "nieuwe geplande datum",
                "plannedWeek": "geplande week",
                "actualDate": "werkelijke datum",
                "shippingCompany": "Verzendbedrijf code"
            },
            "origin": {
                "label": "Oorsprong",
                "operationNumber": "Procesnummer",
                "positionNumber": "Positienummer"
            },
            "residentialUnitsCount": "Aantal wooneenheden",
            "residentialUnitsCountTotal": "Totaal aantal wooneenheden",
            "rikNumber": "ECP-nummer",
            "productGroup": "Productgroep",
            "modelGroup": "Modelgroep",
            "installationType": "Installatietype",
            "netPrice": "Nettoprijs",
            "endCustomerPrice": "Prijs voor eindklant",
            "endCustomerPriceGross": "Prijs voor eindklant incl. btw",
            "retailPrice": "Adviesprijs",
            "alternativeTo": "Alternatief voor",
            "objectionPeriodEnd": "Einddatum bezwaartermijn",
            "instructionsAvailable": "Montagehandleiding beschikbaar",
            "specialCAD": "Speciale CAD",
            "items": {
                "label": "Positie-elementen",
                "sequenceNumber": "Volgnummer",
                "amount": "Hoeveelheid",
                "measureUnit": "Eenheid",
                "number": "Bestelnummer",
                "description": "Omschrijving"
            },
            "tracking": {
                "label": "Tracking",
                "sequenceNumber": "Volgnummer",
                "trackingNumber": "Trackingnummer",
                "status": "Status",
                "receiver": "Ontvanger"
            },
            "chargeable": "vergoeding mogelijk",
            "chargeableReason": "vergoeding mogelijk - reden"
        },
        "updated": "Winkelwagen {name} is bijgewerkt.",
        "updateFailedS": "Winkelwagen {name} kon niet worden bijgewerkt!",
        "inCartTooltip": "Deze aanbieding bevindt zich in de volgende winkelwagens:",
        "addToCartTooltip": "Toevoegen aan winkelwagen",
        "dataTakeover": "Gegevens overnemen uit de aanbieding:",
        "dataOvertake": "Gegevensovername",
        "missingRequiredFields": "Vul alle verplichte velden in!",
        "noDataAvailable": "Er zijn geen gegevens beschikbaar voor overname voor deze positie.",
        "moveOffer": "Aanbieding naar een andere winkelwagen verplaatsen",
        "moveOfferDisabled": "Aanbieding kan niet worden verplaatst omdat er geen andere winkelwagen bestaat.",
        "copyOffer": "Aanbieding naar een andere winkelwagen kopiëren",
        "copyOfferDisabled": "Aanbieding kan niet worden gekopieerd omdat er geen andere winkelwagen bestaat.",
        "deleteOffer": "Aanbieding uit winkelwagen verwijderen",
        "moveOfferS": "Aanbieding verplaatsen",
        "deliveryAddress": "Afleveradres",
        "created": "Winkelwagen {name} is aangemaakt.",
        "createFailed": "Winkelwagen {name} kon niet worden aangemaakt!",
        "cart": "Winkelwagen",
        "carts": "Winkelwagens",
        "copyOfferS": "Aanbieding kopiëren",
        "phoneNotificationChosen": "Telefonische melding is gekozen. Vul de velden voor telefonische melding in.",
        "cartDeleted": "Winkelwagen is verwijderd.",
        "cartDeleteFailed": "Winkelwagen kon niet worden verwijderd!",
        "orderSent": "Bestelling is verzonden.",
        "back": "Terug",
        "addressUpdated": "Adres is bijgewerkt.",
        "addressUpdateFailed": "Adres kon niet worden bijgewerkt, controleer de invoer!",
        "addressCreated": "Adres is toegevoegd aan het adresboek.",
        "addressCreateFailed": "Adres kon niet worden toegevoegd aan het adresboek, controleer de invoer!",
        "orderFailed": "Bestelling kon niet worden verzonden!",
        "updateFailed": "Winkelwagen kon niet worden bijgewerkt!",
        "costNotice": "Let op mogelijke toekomstige kosten. Momenteel zijn er geen kosten.",
        "phoneNotificationRequested": "Telefonische melding gewenst?",
        "phoneNotification": "Meldingstelefoon",
        "editCart": "Winkelwagen bewerken",
        "deleteCart": "Winkelwagen verwijderen",
        "cartIcon": {
            "inCartTooltip": "Deze aanbieding bevindt zich in de volgende winkelwagens: {foundInCarts}",
            "addMarkedItemsTooltip": "Alle gemarkeerde posities aan winkelwagen toevoegen",
            "addAllItemsTooltip": "Alle posities aan winkelwagen toevoegen."
        },
        "updateSuccess": "Naam van winkelwagen is gewijzigd.",
        "updateError": "Naam van winkelwagen kon niet worden gewijzigd!",
        "createSuccess": "Nieuwe winkelwagen is aangemaakt.",
        "createError": "Nieuwe winkelwagen kon niet worden aangemaakt!",
        "createNewCartName": "Nieuwe winkelwagen",
        "addCart": "Winkelwagen toevoegen",
        "createSuccessNotification": "Winkelwagen is succesvol aangemaakt.",
        "deleteSuccessNotification": "Winkelwagen is succesvol verwijderd.",
        "updateSuccessNotification": "Winkelwagen is bijgewerkt.",
        "updateErrorNotification": "Winkelwagen kon niet worden bijgewerkt.",
        "noCartsCreated": "Er zijn nog geen winkelwagens aangemaakt.",
        "deleteModalTitle": "Winkelwagen verwijderen",
        "deleteModalMessage": "Wilt u de winkelwagen <strong>{cartName}</strong> echt verwijderen?",
        "deleteButton": "Winkelwagen verwijderen",
        "total": "Totaal",
        "amountPos": "Aantal pos.",
        "totalSum": "Totaalbedrag",
        "sendOrder": "Bestelling versturen",
        "saveData": "Gegevens opgeslagen",
        "lookInAddressBook": "In adresboek zoeken",
        "deviatingShippingAddress": "Afwijkend afleveradres",
        "homeAddress": "Thuisadres",
        "shippingAddress": "Afleveradres",
        "commission": "Commissie",
        "commissionPlaceholder": "Commissie invullen",
        "constructionProject": "Bouwproject",
        "constructionProjectPlaceholder": "Bouwproject invullen",
        "shipment": {
            "selectCalendarWeek": "Selecteer kalenderweek",
            "dontShipBefore": "Niet leveren vóór week:"
        },
        "legend": {
            "legend": "Legenda",
            "operationCreated": "Proces aangemaakt",
            "inProgress": "In behandeling",
            "offerCreated": "Aanbieding aangemaakt",
            "mandatoryField": "Verplicht veld"
        },
        "modals": {
            "copy": "Kopiëren",
            "confirmDataTakeover": {
                "header": "Gegevens overnemen",
                "body": "Wilt u de gegevens van aanbieding {number} overnemen in de huidige winkelwagen?",
                "cancel": "Annuleren",
                "confirm": "Gegevens overnemen"
            },
            "deleteCartOperation": {
                "header": "Uit winkelwagen verwijderen",
                "body": "Wilt u aanbieding {number} echt uit de winkelwagen verwijderen?",
                "cancel": "Annuleren",
                "confirm": "Verwijderen"
            },
            "addressUpdate": {
                "headerCreate": "Adres aanmaken",
                "headerUpdate": "Adres bijwerken",
                "bodyCreate": "Wilt u het adres echt aanmaken?",
                "bodyUpdate": "Wilt u het adres echt bijwerken?",
                "cancel": "Annuleren",
                "confirmCreate": "Aanmaken",
                "confirmUpdate": "Bijwerken"
            },
            "moveCartOperation": "Aanbieding naar andere winkelwagen verplaatsen",
            "copyCartOperation": "Aanbieding naar winkelwagens kopiëren",
            "orderCart": {
                "header": "Winkelwagen bestellen",
                "body": "Wilt u bestelling {name} echt verzenden?",
                "cancel": "Annuleren",
                "confirm": "Bestelling verzenden"
            },
            "cartDeletion": {
                "header": "Winkelwagen verwijderen",
                "body": "De winkelwagen is leeg. Wilt u winkelwagen {name} verwijderen?",
                "cancel": "Annuleren",
                "confirm": "Verwijderen",
                "success": "Winkelwagen is verwijderd.",
                "error": "Winkelwagen kon niet worden verwijderd!"
            }
        },
        "assignOperation": {
            "title": "Aanbieding naar winkelwagen verplaatsen",
            "newCartLabel": "Nieuwe winkelwagen",
            "tooltipAddToCart": "Toevoegen aan winkelwagen",
            "cancelButtonLabel": "Annuleren",
            "submitButtonLabel": "Toevoegen",
            "invalidCartNameTooltip": "Ongeldige winkelwagennaam. Controleer of deze naam al bestaat en of de naam geldig is.",
            "noCartNameTooltip": "Voer een naam in of selecteer een winkelwagen.",
            "selectCartTooltip": "Toevoegen aan winkelwagen"
        }
    },
    "tableColumns": {
        "source": {
            "label": "H",
            "tooltip": "Herkomst"
        },
        "dealerNumber": {
            "label": "Klantnr.",
            "tooltip": "Dealernummer"
        },
        "releaseDate": {
            "label": "Aanbiedingsdatum"
        },
        "insertTimeOut1": {
            "label": "Aanbiedingsdatum"
        },
        "insertTimeOut2": {
            "label": "Bevestigingsdatum"
        },
        "number": {
            "labelOffer": "Aanbiedingsnr.",
            "labelOrder": "Ordernr."
        },
        "countOfPositions": {
            "label": "Aantal pos.",
            "tooltip": "Aantal posities"
        },
        "status": {
            "label": "Status"
        },
        "canceled": {
            "label": "Geannuleerd"
        },
        "chargeable": {
            "label": "Vergoeding mogelijk",
            "tooltip": "Vergoeding mogelijk",
            "labelShort": "V"
        },
        "inquiryDate": {
            "label": "Aanvraagdatum"
        },
        "releaseDateOrder": {
            "label": "Besteldatum"
        },
        "endCustomerName": {
            "label": "Aanvraag / Naam"
        },
        "inquiryNumber": {
            "labelInquiry": "Aanvraagnr.",
            "labelOrder": "Bestelnr."
        },
        "constructionProject": {
            "label": "Bouwproject"
        },
        "commission": {
            "label": "Commissie"
        },
        "constructionSite": {
            "label": "Bouwplaats"
        },
        "inquiryContact": {
            "label": "Verantwoordelijke"
        },
        "lastUpdatedBy": {
            "label": "Laatst bewerkt door"
        },
        "deliveryAddress": {
            "label": "Afleveradres",
            "noDeliveryAddress": "Geen afleveradres"
        },
        "endCustomerFullAddress": {
            "label": "Eindklant - Naam",
            "address": "Adres eindklant"
        },
        "residentialUnitsCount": {
            "label": "WE",
            "tooltip": "Wooneenheden"
        },
        "sumNetPrice": {
            "label": "Totaal"
        },
        "followUpListOwner": {
            "label": "Lijstbeheerder"
        },
        "description": {
            "label": "Beschrijving"
        },
        "insertTime": {
            "label": "Aangemaakt op"
        },
        "lastUsed": {
            "label": "Laatst gebruikt"
        }
    },
    "bookmarks": {
        "icon": {
            "editOwnResubmissionsOnly": "U kunt alleen uw eigen herinneringen bewerken.",
            "removeFromWatchlist": "Verwijderen van favorietenlijst",
            "addToWatchlist": "Toevoegen aan favorietenlijst"
        },
        "addBookmarks": "Bladwijzer toevoegen",
        "addedBookmarks": "Bladwijzer toegevoegd",
        "removeBookmarks": "Bladwijzer verwijderen",
        "removedBookmarks": "Bladwijzer verwijderd",
        "offers": "Aanbiedingen",
        "orders": "Bestellingen",
        "outgoingOffers": "Uitgaande aanbiedingen",
        "orderConfirmations": "Orderbevestigingen",
        "bookmarks": "Favorietenlijst",
        "myBookmarks": "Mijn favorieten",
        "fullTextSearch": "Volledige tekst zoeken",
        "resetFilter": "Filter resetten"
    },
    "login": {
        "successNotification": "U bent succesvol aangemeld bij het eInfo-systeem.",
        "failNotification": "Er is een fout opgetreden bij het aanmelden. Controleer uw inloggegevens.",
        "mfaNotification": "Uw aanmelding vereist extra bevestiging. Voer de code in die u per e-mail hebt ontvangen.",
        "unknownErrorNotification": "Onbekende fout bij het aanmelden.",
        "enterMfaCode": "Voer de code in die u per e-mail hebt ontvangen.",
        "usernamePlaceholder": "Gebruikersnaam",
        "passwordPlaceholder": "Wachtwoord",
        "submitButton": "Verzenden",
        "resetPassword": "Wachtwoord opnieuw instellen",
        "requestAccess": "Toegang aanvragen",
        "login": "Aanmelden",
        "code": "Code"
    },
    "integrations": {
        "configIntegrations": "Configurator-integratie",
        "iframeRecommendation": "Wij raden voor de integratie van de iFrame een minimale hoogte van <b>800px</b> en een minimale breedte van <b>1000px</b> aan.",
        "contactDataPrepopulation": "Voorinvulling van contactgegevens (optioneel)",
        "useCustomerData": "U kunt de stamgegevens van de ingelogde klant gebruiken om de configurator vooraf in te vullen.",
        "fieldsToPrepopulate": "De volgende velden kunnen vooraf worden ingevuld en via veldnamen in de URL worden toegevoegd:",
        "dealerErrorHeader": "De dealer met nummer {dealerNumbers} is niet volledig geconfigureerd voor gebruik in de configurator!",
        "dealerErrorInstructions": "Controleer of de sjabloon voor aanbiedingen in het dealeraccount correct is ingesteld en geactiveerd.",
        "preDefInsert": "Voorinvulling toevoegen in de code {additionalInfo}",
        "iframePreview": "en iFrame-voorbeeld",
        "colorStyle": "Kleurstijl",
        "selectColorStyle": "Selecteer kleurstijl",
        "backgroundColor": "Achtergrondkleur (optioneel)",
        "dealerCustomer": "Dealerklant",
        "dealerCustomers": "Dealerklanten",
        "enterNumberOrName": "Voer nummer / naam in",
        "sourceCode": "Broncode voor uw website",
        "preview": "Voorbeeld",
        "fieldName": "Veldnaam",
        "importance": "Belang",
        "example": "Voorbeeld",
        "noEntriesFound": "Geen resultaten gevonden",
        "dealerIsntAvailable": "De dealer is niet geconfigureerd of geactiveerd voor gebruik in de configurator.",
        "integrationsMap": {
            "firstname": "Voornaam",
            "lastname": "Achternaam",
            "company": "Bedrijf",
            "city": "Plaats",
            "street": "Straat",
            "houseNumber": "Huisnummer",
            "postcode": "Postcode",
            "countryCode": "Landcode",
            "email": "E-mail",
            "phone": "Telefoon"
        }
    },
    "operationsLegend": {
        "legendTitle": "Legenda",
        "createdOperation": "Proces aangemaakt",
        "inProgress": "In behandeling",
        "offerCreated": "Aanbieding aangemaakt",
        "cancellation": "Annulering",
        "partialCancellation": "Gedeeltelijke annulering",
        "statusDescriptionTitle": "Statusbeschrijving",
        "notStarted": "Niet gestart",
        "inProcess": "In behandeling",
        "delayed": "Vertraagd",
        "partlyDone": "Gedeeltelijk voltooid",
        "completed": "Voltooid",
        "orderConfirmation": "Orderbevestiging",
        "objectionPeriod": "Bezwaarperiode",
        "manufacture": "Productie",
        "shipping": "Verzending",
        "delivery": "Levering"
    },
    "followUp": {
        "onMyList": "op mijn lijst",
        "ownAndForeign": "U heeft {total} achterstallige herinnering{plural}. Daarvan zijn {ownCount} van uzelf en {foreignCount} van anderen.",
        "onlyOwn": "U heeft {total} achterstallige herinnering{plural}.",
        "added": "Herinnering toegevoegd",
        "removed": "Herinnering verwijderd"
    },
    "operations": {
        "shareTransaction": "deze operatie via een link delen",
        "inquiryS": "Navraag over {opNumber}",
        "inquiryContact": "Contactpersoon",
        "protocol": "Protocol bij {opNumber}",
        "email": "E-mail bij {opNumber}",
        "offerType1": "{offerTabTitle_Type1} {opNumber}",
        "orderConfirmation": "Orderbevestiging {opNumber}",
        "orderS": "Order {opNumber}",
        "offerT": "Aanbieding",
        "offer": "Stel een vraag over de volledige aanbieding",
        "linkSent": "De link is succesvol verzonden naar '{email}'.",
        "invalidEmail": "'{email}' is geen geldig e-mailadres.",
        "showPositionDetails": "Details van de positie tonen.",
        "incompleteOperation": "Dit proces is nog niet volledig aangemaakt.",
        "linkRegenerated": "De link is opnieuw gegenereerd. De oude link is niet meer geldig.",
        "linkDeactivated": "De link is gedeactiveerd.",
        "linkCopied": "De link is gekopieerd naar het klembord.",
        "linkCopyFailed": "De link kon niet worden gekopieerd. {text}",
        "order": "Order",
        "share": "delen",
        "linkDescription": "Via een link kunnen andere personen (bijv. klanten) dit proces bekijken.",
        "noPriceInfo": "Voor anderen zijn bij het openen van de link geen prijzen of voorwaarden zichtbaar.",
        "copyLinkHint": "U kunt de link hier kopiëren en handmatig doorsturen.",
        "copyLink": "Link kopiëren",
        "regenerateLink": "Link opnieuw genereren",
        "regenerateLinkTooltip": "Door een nieuwe link te genereren,\nwordt de huidige link ongeldig.",
        "deactivateLink": "Link deactiveren",
        "deactivateLinkTooltip": "Door de link te deactiveren wordt de huidige link ongeldig.\nDe ontvanger heeft dan geen toegang meer.",
        "sendLinkByEmail": "Link per e-mail verzenden",
        "enterEmailHint": "Voer het gewenste e-mailadres in en klik op verzenden.",
        "emailPlaceholder": "Voer e-mail van ontvanger in",
        "resetChanges": "Hiermee worden alle wijzigingen sinds de laatste opslag ongedaan gemaakt.",
        "inquiryTitle": "Navraag over",
        "generalInquiry": "Algemene navraag",
        "complaint": "Klacht",
        "other": "Overig",
        "inquirySent": "Uw aanvraag is verzonden.",
        "operationNumber": "Proces {number}",
        "operationNotFound": "Proces {number} niet gevonden.",
        "position": "Positie",
        "topic": "Onderwerp",
        "selectTopic": "Selecteer onderwerp",
        "message": "Bericht",
        "submit": "Verzenden",
        "source": "Herkomst",
        "customerNumber": "Klantnr.",
        "orderNumber": "Ordernummer",
        "outbound": "Uitgaand",
        "origin": "Oorsprong",
        "numberOfPositions": "Aantal posities",
        "status": "Status",
        "cancellation": "Annulering",
        "orderDate": "Besteldatum",
        "endCustomer": "Eindklant",
        "inquiryName": "Aanvraag / Naam",
        "inquiryNumber": "Aanvraagnr.",
        "constructionProject": "Bouwproject",
        "commission": "Commissie",
        "constructionSite": "Bouwplaats",
        "orderContact": "Besteller",
        "we": "WE",
        "residentialUnits": "Wooneenheden",
        "sum": "Totaal",
        "inquiry": "Navraag",
        "inquiryPlace": "Navraag stellen",
        "inquiryOrder": "Stel een vraag over de volledige order",
        "deliveryAddress": "Afleveradres",
        "lastUpdatedBy": "Laatst bewerkt door",
        "openCustomerOrderConfirmation": "Orderbevestiging klant openen",
        "openOriginalOrder": "Oorspronkelijke order openen",
        "offerDate": "Aanbiedingsdatum",
        "offerNumber": "Aanbiedingsnummer",
        "openCustomerOffer": "Klantaanbieding openen",
        "openOriginalOffer": "Oorspronkelijke aanbieding openen",
        "inquiryDate": "Aanvraagdatum",
        "duplicateAndEdit": "Dupliceren <br/> en bewerken",
        "head": {
            "origin": "Herkomst",
            "customerNumber": "Klantnr.",
            "offerDate": "Aanbiedingsdatum",
            "orderConfirmationDate": "Datum<br/>orderbevestiging",
            "offerNr": "Aanbiedingsnummer",
            "orderNr": "Ordernummer",
            "source": "Oorsprong",
            "openOriginalOffer": "Oorspronkelijke aanbieding openen",
            "openOriginalOrder": "Oorspronkelijke order openen",
            "initialOffer": "Initiële aanbieding",
            "noReferenceFound": "Geen referentie gevonden",
            "amountOfPositions": "Aantal posities",
            "status": "Status",
            "inquiryDate": "Aanvraagdatum",
            "editedLast": "Laatst bewerkt <br /> door",
            "clerk": "Verantwoordelijke",
            "yourReference": "Uw referentie",
            "constructionProject": "Bouwproject",
            "commission": "Commissie"
        }
    },
    "operationsOut": {
        "entryNotFound": "Het item is niet gevonden.",
        "clickForMoreInfo": "Klik op het item voor meer informatie",
        "resetFilter": "Filter resetten",
        "filter": "Filter",
        "tableView": "Tabelweergave",
        "gridView": "Rasterweergave",
        "orderConfirmation": "Orderbevestiging",
        "address": {
            "applyPriceGroup": "Prijsgroep toepassen?",
            "noPriceGroup": "Het adres heeft geen prijsgroep ingesteld.",
            "resetGlobal": "Wilt u de prijsberekening resetten naar de globale instelling?",
            "partnerCompany": "Het bedrijf van de contactpersoon",
            "selectedAddress": "Uw geselecteerde adres",
            "priceGroupApplied": "heeft prijsgroep {priceGroup} ingesteld, wilt u deze toepassen op {documentType}?",
            "currentOffer": "de huidige aanbieding",
            "currentOrderConfirmation": "de huidige orderbevestiging",
            "no": "nee",
            "yes": "ja",
            "endCustomerAddress": "Adres eindklant",
            "searchInAddressBook": "Zoeken in adresboek",
            "saveData": "Gegevens opgeslagen"
        }
    },
    "positions": {
        "specialRequestNoCharge": "Speciale wens aan Renz-medewerker, mogelijk geen vergoeding meer",
        "sequenceNumber": "Volgnummer",
        "quantity": "Hoeveelheid",
        "unit": "Eenheid",
        "articleNumber": "Artikelnummer",
        "description": "Omschrijving",
        "offerNumber": "Aanbiedingsnummer",
        "orderNumber": "Ordernummer",
        "position": "Positie",
        "alternativeTo": "Alternatief voor",
        "fileAttachements": "Bestandsbijlagen",
        "linkedIncomingOperations": "Gekoppelde inkomende processen",
        "linkedOutgoingOperations": "Gekoppelde uitgaande processen",
        "texts": "Teksten",
        "positionCoverLetter": "Voorbrief positie",
        "positionsTexts": "Teksten per positie",
        "origin": "H.",
        "source": "Oorsprong",
        "customerNumber": "Klantnummer",
        "attachement": "Koppeling",
        "amountOfPositions": "Aantal posities",
        "status": "Status",
        "date": "Datum",
        "inquiryOrOrderNumber": "Aanvraag-/Ordernummer",
        "commission": "Commissie",
        "constructionProject": "Bouwproject",
        "constructionSite": "Bouwplaats",
        "residentialUnits": "WE",
        "residentialUnitsCountTooltip": "Wooneenheden",
        "sum": "Totaal",
        "noAttachedOperations": "Geen gekoppelde processen",
        "net": "netto",
        "gross": "bruto",
        "withoutAlternativePositions": "zonder alternatieve posities",
        "assemblyInstructionSent": "De aangevraagde montagehandleiding wordt per e-mail verzonden en is binnenkort beschikbaar in eInfo.",
        "errorOccurred": "Er is een fout opgetreden! Probeer het later opnieuw.",
        "requestAssemblyInstruction": "Montagehandleiding aanvragen",
        "enterEmailPrompt": "Voer een e-mailadres in waarop de montagehandleiding moet worden verzonden.",
        "sendAssemblyInstructionTo": "Montagehandleiding verzenden naar",
        "submit": "Verzenden",
        "requestAssemblyInstructionBreak": "Montagehandleiding<br />aanvragen",
        "deleteFromOperation": "Uit proces verwijderen",
        "confirmDeletePosition": "Wilt u positie \"<strong>{number}</strong>\" echt uit het proces verwijderen?",
        "deleteOperation": "Proces verwijderen",
        "confirmDeleteLastPosition": "Dit is de laatste positie. Weet u zeker dat u het proces uit de winkelwagen wilt verwijderen?",
        "restorePosition": "Positie herstellen",
        "confirmRestorePosition": "Wilt u positie \"<strong>{number}</strong>\" echt herstellen?",
        "marginWarning": "Uw verkoopprijs ligt onder de inkoopprijs.",
        "image": "Afbeelding",
        "positionShort": "Pos.",
        "quantityShort": "Aantal",
        "chargeable": "vergoeding mogelijk",
        "productGroup": "Productgroep",
        "modelGroup": "Modelgroep",
        "color": "Kleur",
        "cancellation": "Annulering",
        "noCancellation": "geen annulering",
        "deliveryDateFromFactory": "Leverdatum vanaf fabriek",
        "tracking": "Pakkettracking",
        "ecpNumber": "ECP-nummer",
        "residentialUnitsShort": "WE",
        "infoToAgent": "Info aan medewerker",
        "unitPrice": "Stuksprijs",
        "actions": "Acties",
        "packagingAndShipping": "Verpakking & verzending",
        "packagingAndShippingDescription": "Dit bedrag wordt in rekening gebracht voor verpakking en verzending.",
        "noPreviousEntry": "Geen eerdere invoer",
        "alternativeToPosition": "Alternatief voor positie {number}",
        "previousValue": "Vorige waarde",
        "amount": "Aantal",
        "sellingPrice": "Verkoopprijs",
        "purchasePrice": "Inkoopprijs",
        "showPositionDetails": "Toon positiedetails.",
        "inquiry": "Navraag",
        "inquiryForPosition": "Navraag over deze positie stellen",
        "deletePosition": "Positie verwijderen",
        "delete": "Verwijderen",
        "recreate": "Herstellen",
        "recreatePosition": "Positie herstellen",
        "noColorSpecification": "geen kleur gespecificeerd",
        "addAdditionalService": "Extra dienst toevoegen",
        "RRP": "Adviesprijs",
        "endcustomer": "Eindklant",
        "margin": "Marge"
    },
    "priceCalculation": {
        "priceCalculation": "Prijscalculatie",
        "globalPricegroup": "Globale prijsgroep",
        "dealerNr": "Dealernummer",
        "manualInput": "Handmatige invoer"
    },
    "address": {
        "deliveryEqualsCompany": "afleveradres is gelijk aan het bedrijfsadres",
        "deliveryUnequalsCompany": "afleveradres is verschillend van het bedrijfsadres",
        "customerNumberAlreadyTaken": "Klantnummer is al in gebruik.",
        "decideCompAndShipAddress": "Geef aan of het bedrijfsadres gelijk is aan het afleveradres.",
        "fillOutMandatoryFields": "Vul alstublieft alle verplichte velden in!",
        "editAddress": "Adres bewerken",
        "addPersonSuccess": "Contactpersoon is toegevoegd.",
        "addAddressSuccess": "Nieuw adres is succesvol aangemaakt.",
        "addPersonError": "Fout bij het toevoegen van de contactpersoon.",
        "addAddressError": "Fout bij het aanmaken van het adres.",
        "closeAddress": "Adres sluiten",
        "unsavedChanges": "U heeft niet-opgeslagen wijzigingen. Weet u zeker dat u het formulier wilt sluiten?",
        "addressBook": "Adresboek",
        "contactPerson": "Contactpersoon",
        "firstName": "Voornaam",
        "lastName": "Achternaam",
        "companyName": "Bedrijfsnaam",
        "vatId": "BTW-nummer",
        "company2OrAdditionalAddress": "Bedrijf 2 / Adrestoevoeging",
        "noChangeToGlobalTaxRate": "Geen wijziging in het globale btw-tarief",
        "postalCode": "Postcode",
        "vat": "BTW",
        "phone": "Telefoon",
        "paymentTerms": "Betalingsvoorwaarden",
        "fax": "Fax",
        "email": "E-mail",
        "website": "Website",
        "contactPersonName": "CONTACTPERSOON (ACHTERNAAM, VOORNAAM)",
        "assignedPriceGroup": "Toegewezen prijsgroep",
        "contactPersonSalutation": "AANHEF CONTACTPERSOON",
        "edit": "Adres bewerken",
        "delete": "Adres verwijderen",
        "createSuccess": "Nieuw adres is succesvol aangemaakt.",
        "createError": "Fout bij het aanmaken van het adres.",
        "freeSearch": "Vrij zoeken",
        "enterSearchTerm": "Voer zoekterm in",
        "type": "Type",
        "company": "Bedrijf",
        "salutation": "Aanhef",
        "firstname": "Voornaam",
        "lastname": "Achternaam",
        "street": "Straat",
        "houseNumber": "Huisnr.",
        "supplement": "Adrestoevoeging",
        "postcode": "Postcode",
        "city": "Plaats",
        "country": "Land",
        "customerNumber": "Klantnr.",
        "typeTooltipCompany": "Bedrijf",
        "typeTooltipContactPerson": "Contactpersoon",
        "setNewAddress": "Nieuw adres aanmaken",
        "setNewEntry": "Nieuwe invoer aanmaken",
        "entry": "invoer",
        "editEntry": "Invoer bewerken",
        "deleteContact": "Contact verwijderen",
        "saveData": "Gegevens opgeslagen",
        "reset": "⟳ resetten",
        "notModified": "Adres is niet gewijzigd.",
        "closeHeader": "Adres sluiten",
        "unsavedChangesWarning": "U heeft niet-opgeslagen wijzigingen. Weet u zeker dat u het formulier wilt sluiten?",
        "contactDeletedSuccess": "Contactpersoon is succesvol verwijderd.",
        "resetChangesInfo": "Hiermee worden alle wijzigingen teruggezet naar de laatst opgeslagen versie.",
        "deleteError": "Adres kon niet worden verwijderd!",
        "multipleDeleteSuccess": "{successfulDeletes} contactpersonen en één adres zijn succesvol verwijderd.",
        "partialDeleteError": "Sommige adressen konden niet worden verwijderd!",
        "unexpectedError": "Er is een onverwachte fout opgetreden!",
        "removeContactHeader": "Contactpersoon verwijderen",
        "deleteEntryHeader": "Invoer verwijderen",
        "removeContactConfirm": "Wilt u de contactpersoon echt verwijderen?",
        "deleteContactConfirm": "Wilt u deze contactpersoon echt verwijderen uit het adresboek? Alle toegewezen contactpersonen worden ook verwijderd.",
        "cancelButton": "annuleren",
        "removeButton": "verwijderen",
        "deleteButton": "verwijderen",
        "customerNumberLabel": "(Klantnummer: {customerNumber})",
        "dealerNumberLabel": "(Dealernummer: {dealerNumber})",
        "dealerNr": "Dealernummer",
        "manualEntry": "Handmatige invoer",
        "newContact": "Nieuwe contactpersoon",
        "fillRequiredFields": "Vul alstublieft alle verplichte velden in!"
    },
    "components": {
        "additionalServices": {
            "addService": "Extra dienst toevoegen",
            "deleteService": "Extra dienst verwijderen",
            "amount": "Aantal",
            "service": "Dienst",
            "description": "Beschrijving",
            "price": "Prijs (€)",
            "salesPrice": "VK:",
            "serviceToPosition": "Dienst bij positie"
        },
        "additionalPosition": {
            "additionalPosition": "Extra positie",
            "headingInPdf": "Koptekst in PDF",
            "addAdditionalPosition": "Extra positie toevoegen",
            "additionalPositionAdd": "Extra positie toevoegen"
        },
        "operationsEmail": {
            "recipient": "Ontvanger",
            "cc": "CC",
            "bcc": "BCC",
            "subject": "Onderwerp",
            "message": "Bericht",
            "sendOfferSubject": "Klantaanbieding {number}",
            "sendOrderConfirmationSubject": "Orderbevestiging {number}",
            "sendOfferMessage": "Geachte heer/mevrouw,\nIn de bijlage vindt u de vrijblijvende aanbieding voor de gevraagde posities.\n\nMet vriendelijke groet,\n{firstName} {lastName} ({email})",
            "sendOrderConfirmationMessage": "Geachte heer/mevrouw,\nIn de bijlage vindt u de orderbevestiging.\n\nMet vriendelijke groet,\n{firstName} {lastName} ({email})",
            "attachment": "Bijlage",
            "sendButton": "Verzenden",
            "offerSentNotification": "De aanbieding is verzonden.",
            "orderConfirmationSentNotification": "De orderbevestiging is verzonden.",
            "errorNotification": "Er is een fout opgetreden. Probeer het later opnieuw.",
            "offerCouldNotBeSent": "Aanbieding kon niet worden opgeslagen"
        },
        "operationDetails": {
            "manualPriceGroup": "Handmatige invoer",
            "globalPriceGroup": "Globale prijsgroep",
            "dealerNumber": "Dealernummer",
            "offerTemplate": "Aanbiedingssjabloon",
            "orderConfirmationTemplate": "Orderbevestigingssjabloon",
            "couldNotBeCreated": " kon niet worden aangemaakt",
            "offer": "Aanbieding",
            "orderConfirmation": "Orderbevestiging",
            "isNotCompleted": " is nog niet voltooid. Controleer of er een geldig sjabloon is ingesteld.",
            "wasSuccessfullySaved": " is succesvol opgeslagen.",
            "offerCouldNotBeSaved": "Aanbieding kon niet worden opgeslagen",
            "wasSuccessfullyCreated": " is succesvol aangemaakt.",
            "saveToGeneratePDF": "Sla het document op om de PDF te genereren.",
            "selectAtLeastOnePosition": "Selecteer minstens één positie",
            "markedPositionsToCart": "geselecteerde posities naar winkelwagen",
            "convertToCustomerOffer": "omzetten in klantaanbieding",
            "convertToOrderConfirmation": "omzetten in orderbevestiging",
            "transformTo": "omzetten naar",
            "sendOfferToCustomer": "Aanbieding naar <br /> klant verzenden",
            "createOrderConfirmationAndEdit": "Orderbevestiging aanmaken <br /> en bewerken",
            "sendOrderConfirmationToCustomer": "Orderbevestiging naar <br /> klant verzenden",
            "offerChanged": "Aanbieding is gewijzigd, sla op!",
            "noCorrespondingOrder": "Geen bijbehorende order beschikbaar. Wacht totdat de order beschikbaar is in het Renz-systeem!",
            "orderCanceled": "Order is geannuleerd.",
            "allPositionsCanceled": "Alle relevante posities in de order zijn geannuleerd.",
            "orderConfirmationChanged": "Orderbevestiging is gewijzigd, sla op!",
            "orderConfirmationNotComplete": "Orderbevestiging is nog niet voltooid.",
            "offerAlreadySent": "Aanbieding is al naar de klant verzonden",
            "orderConfirmationAlreadySent": "Orderbevestiging is al naar de klant verzonden",
            "orderConfirmationTemplateError": "Orderbevestigingssjabloon kon niet worden aangemaakt: ",
            "offerNotChanged": "Aanbieding is niet gewijzigd!",
            "orderConfirmationNotChanged": "Orderbevestiging is niet gewijzigd!",
            "offerReset": "Aanbieding terugzetten naar laatst opgeslagen status",
            "orderConfirmationReset": "Orderbevestiging terugzetten naar laatst opgeslagen status",
            "orderNotComplete": "Order is nog niet voltooid.",
            "offerNotCompleted": "Aanbieding is nog niet voltooid. Controleer of de PDF beschikbaar is. Als deze ontbreekt, sla opnieuw op met een geldig sjabloon!",
            "templateNotAvailable": "Er is geen sjabloon beschikbaar voor de dealernummer van dit proces of uw account.",
            "offerDataInherited": "De instellingen van de oorspronkelijke aanbieding(en) van de posities worden overgenomen.",
            "invalid": "ongeldig",
            "dataFromIncomingOrder": "De gegevens uit de inkomende order worden overgenomen."
        },
        "table": {
            "changesInOperations": "Wijzigingen in het proces",
            "fieldName": "Veldnaam",
            "previousValue": "Vorige waarde",
            "currentValue": "Huidige waarde",
            "watchlist": "Favorietenlijst",
            "offerNumber": "Aanbiedingsnummer",
            "transationStemsFrom": "Het proces is gebaseerd op een uitgaande aanbieding",
            "offerGotChanged": "De aanbieding {offerNumber} is extern gewijzigd, hier wordt de aangepaste versie weergegeven.",
            "noCurrentEntry": "Geen actuele invoer",
            "noEarlierEntry": "Geen eerdere invoer",
            "fields": {
                "attachmentField": {
                    "offer": "Aanbieding",
                    "orderConfirmation": "Orderbevestiging",
                    "invoice": "Factuur",
                    "deliveryNote": "Pakbon",
                    "twoDOverall": "2D-totaalbeeld",
                    "twoDDetail1": "2D-detailweergave 1",
                    "twoDDetail2": "2D-detailweergave 2",
                    "twoDImage": "2D-afbeelding",
                    "threeDImage": "3D-afbeelding",
                    "assemblyInstruction": "Montagehandleiding",
                    "dxfFile": "DXF-bestand"
                },
                "cancellation": {
                    "none": "geen annulering",
                    "full": "alle posities geannuleerd",
                    "partial": "gedeeltelijke annulering"
                },
                "trackingList": {
                    "delivered": "geleverd",
                    "inDelivery": "in levering",
                    "inTransit": "onderweg",
                    "noData": "geen gegevens beschikbaar",
                    "externalLink": "externe link naar {shippingCompany}",
                    "noTrackingLink": "geen trackinglink beschikbaar",
                    "shippingCompany": "Vervoerder: {shippingCompany}",
                    "receipt": "Ontvangen door: {receiver}"
                },
                "trackingField": {
                    "trackingLabel": "Pakkettracking",
                    "deliveredStatus": "{deliveredCount} van {count} geleverd",
                    "showDetails": "Details tonen",
                    "notAvailable": "niet beschikbaar"
                },
                "status": {
                    "orderConfirmation": "Orderbevestiging",
                    "shipping": "Verzending",
                    "manufacture": "Productie",
                    "offerCreated": "Aanbieding aangemaakt",
                    "offerInProgress": "Aanbieding in bewerking",
                    "offerEmailSent": "Aanbiedingse-mail {emailDetails} verzonden",
                    "noOfferEmailSent": "Nog geen aanbiedingse-mail verzonden",
                    "emailDetails": "laatst verzonden naar {recipient} op {timestamp}",
                    "orderConfirmationEmailSent": "Orderbevestigingse-mail {emailDetails} verzonden",
                    "noOrderConfirmationEmailSent": "Nog geen orderbevestigingse-mail verzonden",
                    "inConfirmCount": "{count} positie(s) in bewerking",
                    "orderConfirmed": "Order bevestigd",
                    "orderInProgress": "Order in bewerking",
                    "objectionPeriod": "Bezwaarperiode",
                    "inObjectionPeriod": "{count} positie(s) binnen bezwaartermijn",
                    "objectionPeriodExpiredForSome": "Bezwaartermijn verlopen voor {count} positie(s)",
                    "objectionPeriodExpired": "Bezwaartermijn verlopen",
                    "objectionPeriodAfterConfirmation": "Bezwaartermijn start na orderbevestiging",
                    "inManufacture": "{count} positie(s) in productie",
                    "manufactureCompleted": "Productie voltooid",
                    "noItemsInManufacture": "geen posities in productie",
                    "inReadyToShip": "{count} positie(s) in verzendvoorbereiding",
                    "readyToShipCompleted": "Verzendvoorbereiding afgerond",
                    "noItemsReadyToShip": "geen posities in verzendvoorbereiding",
                    "inShipment": "{count} positie(s) verzonden",
                    "delivered": "{count} positie(s) geleverd",
                    "noItemsInShipment": "geen posities in levering",
                    "missingTracking": "Er zijn geen (volledige) trackinggegevens beschikbaar.",
                    "orderedMultiple": "{count} keer besteld.",
                    "notOrdered": "Nog niet besteld.",
                    "fullyOrdered": "volledig besteld",
                    "orderedCount": "{count} positie(s) besteld",
                    "outboundOfferCreated": "Uitgaande aanbieding aangemaakt",
                    "noOutboundOfferCreated": "geen uitgaande aanbieding aangemaakt",
                    "orderConfirmationCreated": "Orderbevestiging aangemaakt",
                    "noOrderConfirmationCreated": "geen orderbevestiging aangemaakt",
                    "operationStatusUpdated": "De status van proces {operationNumber} is gewijzigd naar {statusLabel} en de notitie is bijgewerkt.",
                    "operationStatusOnlyUpdated": "De status van proces {operationNumber} is gewijzigd naar {statusLabel}.",
                    "operationNoteUpdated": "De notitie van proces {operationNumber} is bijgewerkt.",
                    "noPermissionToEditStatus": "U heeft geen rechten om de status te wijzigen",
                    "defaultFirstName": "Mijn voornaam",
                    "defaultLastName": "Mijn achternaam",
                    "operationTracking": "Procestracking voor {operationNumber}",
                    "status": "Status",
                    "notes": "Notities",
                    "insertTimestampLine": "Tijdstempelregel invoegen",
                    "noNotesAvailable": "Geen notities beschikbaar",
                    "clickIconToMakeChanges": "Klik op het pictogram om wijzigingen aan te brengen",
                    "inObjectionPeriodUntil": "Positie binnen bezwaartermijn tot {date}",
                    "objectionPeriodExpiredOn": "Bezwaartermijn verlopen{dateInfo}",
                    "dateOn": " op {date}",
                    "positionInManufacture": "Positie in productie",
                    "manufactureNotStarted": "Productie nog niet gestart",
                    "positionDelivered": "Positie geleverd",
                    "positionShippedNoTracking": "Positie verzonden\n\nGeen trackinggegevens beschikbaar.",
                    "positionShipped": "Positie verzonden",
                    "positionNotShipped": "Positie nog niet verzonden",
                    "positionReadyToShip": "Positie in verzendvoorbereiding",
                    "noPositionsInShipping": "geen posities in verzending"
                },
                "number": {
                    "offerNumber": "Aanbieding / Nummer {operationNumber}",
                    "orderNumber": "Order / Nummer {operationNumber}",
                    "positionNumber": "\nPositie {positionNumber}"
                },
                "chargeableField": {
                    "CAD": "Pos is nu speciale CAD",
                    "NTF": "Pos is NettoFix",
                    "BTF": "Pos is BrutoFix",
                    "GNE": "Reden onbekend",
                    "CPY": "Initieel bij kopiëren in BackOffice",
                    "SBE": "Achteraf ingevoerd door medewerker",
                    "BNI": "Afstemming met RENZ ID medewerker",
                    "BNA": "Boni op hoofdniveau uitgeschakeld => niet RIK-vergoedbaar",
                    "SW": "Klant heeft een speciale wens opgegeven",
                    "SBO": "Achteraf bewerkt door medewerker",
                    "SBA": "Achteraf bewerkt door medewerker",
                    "SBR": "Uitsluiting wegens handmatige korting",
                    "SHO": "Invoer via eConfig",
                    "WVU": "Goederenverkeer VU (verbonden bedrijven)",
                    "QNR": "RIT-bestelling, bron is niet RIK-vergoedbaar",
                    "chargeable": "Positie is vergoedbaar.",
                    "notChargeable": "Positie is niet vergoedbaar",
                    "reason": "\n\n{reason}",
                    "notChargeableOperation": "Proces niet vergoedbaar. {reasonsText}",
                    "partiallyChargeable": "{chargeableCount} van {totalCount} posities zijn vergoedbaar. {reasonsText}",
                    "fullyChargeable": "Alle posities van het proces zijn vergoedbaar"
                }
            }
        },
        "priceWizard": {
            "priceWizard": "Prijswizard",
            "showPricewizard": "Prijswizard tonen",
            "applyConfirmation": "Bevestiging toepassen",
            "applyPriceGroupPrompt": "Wilt u de prijsgroep toepassen op het hele proces of alleen op deze positie?",
            "applyRestricted": "toepassen op positie",
            "applyEntireOperation": "toepassen op het gehele proces",
            "applyMarginWarning": "Uw verkoopprijs ligt onder uw inkoopprijs. Weet u zeker dat u wilt doorgaan?",
            "resetConfirmation": "Hiermee worden alle wijzigingen teruggezet naar de laatst opgeslagen versie.",
            "priceGroupNotModified": "Prijsgroep is niet gewijzigd.",
            "sellingPrice": "Verkoopprijs",
            "inputInEUR": "Invoer in EUR",
            "additionalPositionNumber": "Extra positie nr.",
            "quantity": "Aantal posities",
            "RRP": "Adviesprijs",
            "sale": "Korting",
            "discount": "Korting",
            "inputInPercent": "Invoer in %",
            "specificationInEur": "Invoer in EUR",
            "subtotal": "Subtotaal",
            "surcharge": "Toeslag",
            "currentPurchasePrice": "Huidige inkoopprijs",
            "difference": "Verschil",
            "originalPurchasePrice": "Oorspronkelijke inkoopprijs",
            "basisForCalculations": "(Basis voor berekeningen)",
            "purchasePrice": "Inkoopprijs",
            "entirePriceGroup": "Volledige prijsgroep",
            "selectPriceGroup": "Selecteer prijsgroep",
            "showDiscountPDFs": "Toon korting in PDF van aanbieding en orderbevestiging",
            "costType": "Kostensoort",
            "net": "Netto",
            "gross": "Bruto",
            "percentageInput": "Invoer in %",
            "closeIcon": "Sluiten",
            "searchIcon": "Zoeken",
            "editEndcustomerAddress": "Adres eindklant bewerken"
        },
        "richtext": {
            "bold": "Vet",
            "italic": "Cursief",
            "underline": "Onderstrepen",
            "strike": "Doorhalen",
            "align": "Uitlijning",
            "blockquote": "Citaat",
            "code_block": "Codeblok",
            "list": "Lijst",
            "color": "Tekstkleur",
            "background": "Achtergrondkleur",
            "image": "Afbeelding invoegen",
            "link": "Link invoegen",
            "clean": "Opmaak verwijderen",
            "priceGroupNotModified": "Prijsgroep is niet gewijzigd."
        },
        "datepicker": {
            "days": [
                "zondag",
                "maandag",
                "dinsdag",
                "woensdag",
                "donderdag",
                "vrijdag",
                "zaterdag"
            ],
            "daysShort": [
                "Zo",
                "Ma",
                "Di",
                "Wo",
                "Do",
                "Vr",
                "Za"
            ],
            "daysMin": [
                "Zo",
                "Ma",
                "Di",
                "Wo",
                "Do",
                "Vr",
                "Za"
            ],
            "months": [
                "januari",
                "februari",
                "maart",
                "april",
                "mei",
                "juni",
                "juli",
                "augustus",
                "september",
                "oktober",
                "november",
                "december"
            ],
            "monthsShort": [
                "Jan",
                "Feb",
                "Mrt",
                "Apr",
                "Mei",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dec"
            ],
            "today": "Vandaag",
            "clear": "Wissen",
            "titleFormat": "MM y",
            "format": "dd.mm.yyyy"
        },
        "overlay": {
            "closeOffer": "Aanbieding sluiten",
            "unsavedChanges": "U heeft niet-opgeslagen wijzigingen. Weet u zeker dat u de aanbieding wilt sluiten?"
        },
        "followUp": {
            "removeResubmissionDate": "Herinneringsdatum verwijderen",
            "setResubmissionDate": "Herinneringsdatum instellen",
            "onlyEditResubmissions": "U kunt alleen uw eigen herinneringen bewerken."
        },
        "documentTemplate": {
            "template": "Sjabloon",
            "offerTemplate": "Aanbiedingssjabloon",
            "orderConfirmationTemplate": "Orderbevestigingssjabloon",
            "offerTemplateGotSaved": "Het aanbiedingssjabloon is succesvol opgeslagen.",
            "filesAllowed": "Alleen png- en jpg/jpeg-bestanden zijn toegestaan.",
            "resetToDefault": "Terugzetten naar standaard",
            "letterPaper": "Briefpapier",
            "defineLayoutThroughBGImages": "Lay-out bepalen via achtergrondafbeelding(en)",
            "defineLayoutThroughLogo": "Lay-out bepalen via logobestand",
            "logoPosition": "Logopositie",
            "verticalOrientation": "Verticale uitlijning",
            "horizontalOrientation": "Horizontale uitlijning",
            "verticalDisplacement": "Verticale verschuiving",
            "horizontalDisplacement": "Horizontale verschuiving",
            "noLogoAvailable": "Nog geen logo beschikbaar",
            "deleteFile": "Bestand verwijderen",
            "footer": "Voettekst",
            "noFooterAvailable": "Nog geen voettekst beschikbaar",
            "firstPage": "Eerste pagina",
            "noTemplateAvailable": "Nog geen sjabloon beschikbaar",
            "templateNotModified": "Sjabloon is niet gewijzigd.",
            "subsequentPages": "Volgende pagina's",
            "margins": "Paginamarges",
            "top": "Boven",
            "right": "Rechts",
            "bottom": "Onder",
            "left": "Links",
            "forSubsequentPages": "voor volgende pagina's",
            "preview": "Voorbeeld",
            "mandatoryField": "Verplicht veld",
            "textContent": "Tekstinvoer",
            "contact": "Contactpersoon",
            "defaultContactPerson": "Standaard wordt de ingelogde gebruiker als contactpersoon weergegeven. U kunt dit uitschakelen in 'Sjabloon bewerken'.",
            "displayedContactPerson": "Weergegeven contactpersoon in sjabloonkop*",
            "eMailOfContact": "E-mail van contactpersoon*",
            "useLoggedInUserAsContact": "Ingelogde gebruiker als contactpersoon gebruiken.",
            "telephoneOfContact": "Telefoonnummer van contactpersoon*",
            "currentLoggedInUser": "Huidige ingelogde gebruiker:",
            "emailContent": "E-mailtekst",
            "emailSubject": "E-mailonderwerp*",
            "subjectLine": "Dit is een onderwerp",
            "emailBody": "E-mail begeleidende tekst",
            "pdfContent": "PDF-teksten",
            "introductionText": "Inleidende tekst",
            "introContent": "Hier staat de inleiding",
            "originalCoverLetter": "Originele voorbrief",
            "closingNote": "Afsluitende tekst (weergegeven na de posities)",
            "closingText": "Hier staat de afsluitende tekst",
            "coverLetter": "Voorbrief",
            "deliveryTimeAndPaymentTerms": "Levertijd en betalingsvoorwaarden*",
            "deliveryTime": "Levertijd",
            "paymentTermsDescription": "Beschrijving van de betalingsvoorwaarden",
            "emailBodyPlaceholder": "Hier komt de begeleidende tekst",
            "paymentTerms": "Betalingsvoorwaarden*",
            "editTemplate": "Sjabloon bewerken"
        },
        "pcalc": {
            "originType": "Herkomsttype",
            "uvp": "Adviesprijs",
            "markupOnPurchasePrice": "Marge op inkoopprijs",
            "discountOnRRP": "Korting op adviesprijs",
            "minMarginOnPurchasePrice": "Minimale marge op inkoopprijs",
            "addPriceGroup": "Prijsgroep toevoegen",
            "priceCalculation": "Prijscalculatie",
            "globalPriceCalculation": "Globale prijscalculatie",
            "priceGroups": "Prijsgroepen",
            "updateSuccess": "De wijzigingen zijn succesvol bijgewerkt.",
            "updateError": "De wijzigingen konden niet worden opgeslagen.",
            "createSuccess": "De prijscalculatie is succesvol opgeslagen.",
            "createError": "De prijscalculatie kon niet worden opgeslagen.",
            "deleteSuccess": "De prijscalculatie is succesvol verwijderd.",
            "deleteError": "De prijscalculatie kon niet worden verwijderd.",
            "defaultCalculation": "Standaardcalculatie",
            "groupNamePlaceholder": "Groepsnaam",
            "editGroupName": "Groepsnaam bewerken",
            "deleteGroup": "Groep verwijderen",
            "resetTooltip": "Hiermee zet u alle wijzigingen terug naar de laatst opgeslagen versie.",
            "reset": "Resetten",
            "invalid": "Ongeldig",
            "notModified": "Prijsgroep is niet gewijzigd.",
            "validity": "Geldigheid",
            "daysValidPlaceholder": "bijv. 14",
            "days": "Dagen",
            "fixedDates": "Vaste data",
            "datePlaceholder": "Van",
            "internalComment": "Interne opmerking",
            "commentNote": "(wordt niet op afdrukken weergegeven)",
            "commentPlaceholder": "Uw opmerking bij de datum",
            "addFixedDate": "Vaste datum toevoegen",
            "exceptionRule": "Uitzonderingsregel",
            "exceptionRules": "Uitzonderingsregels",
            "youCanIndivualize": "U kunt uw calculatie personaliseren met de velden 'Attribuut', 'Vergelijkingsoperator' en 'Waarde zoeken' (meervoudige selectie mogelijk).",
            "processedTopBottom": "Regels worden van boven naar beneden verwerkt.",
            "filter": "Filter",
            "addExceptionRule": "Uitzonderingsregel toevoegen",
            "exceptionRuleTitle": "Titel van uitzonderingsregel",
            "removeFilter": "Filter verwijderen",
            "comparisonOperator": "Vergelijkingsoperator",
            "installationType": "Montagetype",
            "netPrice": "Nettoprijs",
            "residentialUnitsCount": "Wooneenheden",
            "residentialUnitsCountTotal": "Totaal aantal wooneenheden",
            "productGroup": "Productgroep",
            "modelGroup": "Modelgroep",
            "equalsExample": "Gelijk (bijv. 5 = 5)",
            "notEqualsExample": "Ongelijk (bijv. 5 ≠ 3)",
            "greaterExample": "Groter dan (bijv. 5 > 3)",
            "lessExample": "Kleiner dan (bijv. 3 < 5)",
            "greaterOrEqualExample": "Groter of gelijk (bijv. 5 ≥ 5)",
            "lessOrEqualExample": "Kleiner of gelijk (bijv. 3 ≤ 5)",
            "attribute": "Attribuut"
        },
        "pcalcGroup": {
            "priceGroup": "Prijsgroep",
            "globalPriceGroup": "Globale prijsgroep",
            "dealerNr": "Dealernummer",
            "selectPriceGroup": "Prijsgroep selecteren",
            "manualInput": "Handmatige invoer",
            "activePriceGroup": "Actieve prijsgroep",
            "changePriceGroup": "Prijsgroep wijzigen",
            "applyPriceGroup": "Prijsgroep toepassen",
            "inclusive": "incl.",
            "vat": "btw",
            "gotApplied": "Prijsgroep is succesvol toegepast."
        },
        "noOffer": "Geen aanbieding",
        "operationsFilter": {
            "all": "allemaal",
            "taskSent": "Orderbevestiging verzonden",
            "offerSent": "Aanbieding verzonden",
            "allSources": "Alle bronnen",
            "user_status": "Gebruikersstatus",
            "internal_status": "Interne status",
            "undefined": "Alle statussen",
            "inProgress": "In bewerking",
            "created": "Aanbieding aangemaakt",
            "outOfferCreated": "Uitgaande aanbieding aangemaakt",
            "ordered": "Besteld",
            "open_dealer": "Open",
            "lost_dealer": "Verloren",
            "won_dealer": "Gewonnen",
            "waitingForResponse_dealer": "Wachten op antwoord",
            "followup_dealer": "Herinnering",
            "locked_dealer": "Geblokkeerd",
            "open_internal": "Open",
            "lost_internal": "Verloren",
            "won_internal": "Gewonnen",
            "waitingForResponse_internal": "Wachten op antwoord",
            "followup_internal": "Herinnering",
            "locked_internal": "Geblokkeerd",
            "confirmed": "Orderbevestiging",
            "inObjectionPeriod": "Binnen bezwaarperiode",
            "delayed": "Vertraging",
            "manufactured": "In productie",
            "readyToShip": "Klaar voor verzending",
            "inShipment": "Verzonden",
            "delivered": "Geleverd",
            "canceled": "Geannuleerd",
            "applyFilter": "Filter toepassen",
            "resetFilter": "Filter resetten",
            "agent": "Verantwoordelijke",
            "selectAgent": "Selecteer verantwoordelijke",
            "representative1": "Vertegenwoordiger 1",
            "selectRepresentative": "Selecteer vertegenwoordiger",
            "selectModelGroup": "Modelgroep selecteren",
            "modelGroup": "Modelgroep",
            "installationType": "Montagetype",
            "selectInstallationType": "Montagetype selecteren",
            "residentialUnits": "Wooneenheden",
            "unitPrice": "Stuksprijs",
            "advancedSearch": "Uitgebreid zoeken",
            "dealerCustomers": "Dealerklanten",
            "enterNumberOrName": "Nummer / naam invoeren",
            "until": "tot",
            "filterTimeRange": "Periode filteren",
            "from": "van",
            "freeSearch": "Vrij zoeken",
            "origin": "Herkomst",
            "selectOrigin": "Herkomst selecteren",
            "selectStatus": "Status selecteren",
            "status": "Status",
            "filter": "Filter"
        },
        "operationProtocol": {
            "protocolForOffer": "Protocol voor aanbieding {number}",
            "noProtocol": "Er is nog geen protocol voor deze aanbieding.",
            "timestamp": "Tijdstip",
            "action": "Handeling",
            "editor": "Bewerker",
            "details": "Details",
            "legend": "Legenda",
            "emailSent": "E-mail verzonden",
            "added": "Toegevoegd",
            "created": "Aangemaakt",
            "edited": "Bewerkt",
            "close": "Sluiten",
            "protocol": "Protocol",
            "operationChanges": "Proceswijzigingen",
            "fieldName": "Veldnaam",
            "previousValue": "Vorige waarde",
            "currentValue": "Huidige waarde",
            "noPreviousEntry": "Geen eerdere invoer",
            "noCurrentEntry": "Geen huidige invoer",
            "creationOrderConfirmation": "aanmaak van de orderbevestiging",
            "creationOffer": "aanmaak van de offerte",
            "processingOrderConfirmation": "verwerking van de orderbevestiging",
            "processingOffer": "verwerking van de offerte"
        },
        "date": {
            "dateDeleteValidationModal": {
                "question": "Wilt u de datum echt verwijderen?",
                "cancelButton": "annuleren",
                "deleteButton": "ja"
            },
            "followUpDeleteValidationModal": {
                "question": "Wilt u het proces echt van de favorietenlijst verwijderen?",
                "cancelButton": "annuleren",
                "deleteButton": "ja"
            }
        }
    },
    "config": {
        "open": "Open",
        "lost": "Verloren",
        "won": "Gewonnen",
        "locked": "Geblokkeerd",
        "waitingForResponse": "Wacht op reactie",
        "followup": "Herinnering",
        "country": {
            "DE": "Duitsland",
            "AT": "Oostenrijk",
            "SE": "Zweden",
            "LU": "Luxemburg",
            "BE": "België"
        },
        "hints": {
            "placeholderHint": "U kunt de volgende placeholders gebruiken:<br />[Nummer]<br />[Bedrijf]<br />[Voornaam]<br />[Achternaam]<br />[Bouwproject]<br />[Commissie]",
            "imageFormatHint": "Beeldformaat moet .jpg of .png zijn. De optimale resolutie is 2480x3508 pixels. Andere formaten zijn mogelijk, maar de kwaliteit kan dan minder zijn.",
            "imageSimpleFormatHint": "Beeldformaat moet .jpg of .png zijn. De optimale resolutie voor het logo is 1240x680 pixels. Voor de voettekst is 2480x240 pixels (ca. 3 cm hoog) ideaal. Andere formaten zijn mogelijk, maar de kwaliteit kan verminderen."
        },
        "shippingCompanies": {
            "1003": "DPD",
            "1004": "Spedition Kirchberg/Murr",
            "1005": "Spedition Häring",
            "1006": "Spedition Kunzendorf",
            "1007": "Spedition Franz Lerner GmbH",
            "1010": "Elmar Maurus Logistic",
            "1011": "Spedition Ulmschneider",
            "1012": "DHL Freight GmbH",
            "1013": "Spedition Weckerle",
            "1014": "Spedition H. v. Wirth",
            "1017": "UPS",
            "1023": "Spedition Redemann",
            "1032": "Spedition Dachser",
            "1044": "Transportbedrijf Gert Treitinger",
            "1045": "Spedition Rentschler",
            "1046": "DSV Stuttgart",
            "1047": "TNT",
            "1048": "Spedition Dischinger Ebersbach",
            "1049": "Spedition Atege",
            "1051": "Spedition Schmalz + Schön",
            "1053": "Spedition SCS Stuttgart GmbH",
            "1054": "Spedition L.W.Cretschmar GmbH&Co.KG",
            "1055": "Spedition Trautwein",
            "1056": "Spedition L.Wackler Wwe.Nachf.GmbH",
            "1057": "Spedition Dacotrans Grosskopf GmbH & Co.KG",
            "1058": "Ebenroth - pure logistiek",
            "1059": "HTL-Peter Messner GmbH / Handel-Transport-Logistiek",
            "1060": "Kunzendorf Sped. GmbH / vestiging Schkeuditz",
            "1061": "Spedition ROHLIG SUUS Logistics SA",
            "1062": "Optimal Koerier",
            "1063": "Heppner Internationale / Spedition GmbH Co. KG",
            "1064": "DACHSER SE Spedition",
            "1065": "Renz Frankrijk in FR Spedition",
            "1066": "Renz Polen in PL Spedition",
            "1067": "Inotherm in SI Spedition",
            "1068": "Kühne + Nagel"
        },
        "operationSources": {
            "10": {
                "label": "Backoffice"
            },
            "20": {
                "label": "eConfig Pro"
            },
            "30": {
                "label": "eConfig"
            },
            "40": {
                "label": "RIT"
            },
            "50": {
                "label": "eShop"
            },
            "60": {
                "label": "eInfo"
            }
        },
        "installationTypeCodes": {
            "1": "Inbouw/deelwandmontage",
            "2": "Opbouwmontage",
            "3": "Vrijstaand, uitname voorzijde",
            "4": "Vrijstaand, uitname achterzijde",
            "5": "Muurdoorwerpmontage",
            "6": "Hekmontage",
            "7": "Zijmontage deur, uitname achterzijde",
            "8": "Contactzuil",
            "9": "Muurdoorwerp met horizontale boxen",
            "10": "Enkelmontage",
            "11": "Zijmontage deur, uitname voorzijde",
            "12": "Vervangingsdeuren/kappen/omhulsels",
            "13": "Klant-specifieke fronten",
            "14": "Muurdoorwerpmontage (alleen Zwitserland)"
        },
        "productGroupCodes": {
            "1": "Renz",
            "2": "Startline",
            "3": "Renz Plan"
        },
        "modelGroupCodes": {
            "10": "Verticale brievenbussen, uitname voorzijde",
            "12": "Brievenbussen zijdeel deur, uitname achterzijde",
            "13": "Horizontale brievenbussen, uitname voorzijde",
            "14": "Muurinbouw, uitname achterzijde",
            "15": "Lijn Commercial / Lijn Privé",
            "16": "Intercom/belsystemen",
            "17": "Hekbrievenbussen/losse onderdelen",
            "20": "Opslagsystemen",
            "21": "Postverdelers doorwerpsysteem",
            "22": "Postverdelers frontinvoer",
            "23": "Brief- en pakketboxsystemen CLASSIC",
            "25": "Startline verticale brievenbussen, uitname voorzijde",
            "26": "Startline horizontale brievenbussen, uitname voorzijde",
            "27": "Startline zijdeel deur, uitname achterzijde",
            "29": "Budget zijdeel deur, uitname achterzijde",
            "30": "Informatiekasten",
            "40": "Autodealerskasten",
            "41": "Apothekerskasten",
            "42": "Veiligheidsbrievenbussen",
            "43": "Dag-/nachtbrievenbussen",
            "50": "Exportmodellen Zwitserland",
            "58": "Budget horizontale brievenbussen, uitname voorzijde",
            "60": "RENZ PLAN verticale brievenbussen, uitname voorzijde",
            "61": "RENZ PLAN horizontale brievenbussen, uitname voorzijde",
            "62": "RENZ PLAN verticale brievenbussen, uitname achterzijde",
            "63": "RENZ PLAN zuilen",
            "64": "RENZ PLAN S zijdeel brievenbussen",
            "65": "RENZ PLAN S muurinbouw, uitname achterzijde",
            "67": "RENZ PLAN S verticale brievenbussen, uitname voorzijde",
            "68": "RENZ PLAN SL horizontale brievenbussen, Zwitserland",
            "78": "MEFA",
            "90": "Reserveonderdelen met gravure",
            "97": "Reserveonderdelen"
        }
    },
    "general": {
        "foldIn": "Inklappen",
        "removeExceptionFilter": "Filter verwijderen. Let op: een uitzonderingsregel zonder filter wordt automatisch verwijderd bij het opslaan.",
        "exceptionWithoutFilter": "Uitzonderingsregels zonder filter worden automatisch verwijderd. Sla algemene berekeningen buiten de uitzonderingsregels op.",
        "foldOut": "Uitklappen",
        "logoutWarning": "U wordt over {logoutInMinutes} minuut{plural} uitgelogd als u geen acties uitvoert.",
        "errorOccurred": "Er is een fout opgetreden! Laad de pagina opnieuw en probeer het later nogmaals.",
        "fullText": "Volledige tekst",
        "removeFilter": "Filter verwijderen",
        "warning": "Waarschuwing",
        "pushDown": "Naar beneden verplaatsen",
        "pushUp": "Naar boven verplaatsen",
        "restore": "Herstellen",
        "ok": "OK",
        "yes": "Ja",
        "no": "Nee",
        "send": "Verzenden",
        "cancel": "Annuleren",
        "save": "Opslaan",
        "close": "Sluiten",
        "back": "Terug",
        "next": "Volgende",
        "delete": "Verwijderen",
        "edit": "Bewerken",
        "noted": "Opgeslagen",
        "note": "Opslaan",
        "beeingLoaded": "Bezig met laden...",
        "pleaseWait": "Even geduld alstublieft...",
        "preview": "Voorbeeld",
        "logo": "Logo",
        "selectFile": "Bestand selecteren",
        "legend": "Legenda",
        "eMailAddress": "E-mailadres",
        "telephone": "Telefoonnummer",
        "webAddress": "Website-adres",
        "add": "Toevoegen",
        "mr": "Dhr.",
        "mrs": "Mevr.",
        "others": "Overig",
        "planned": "gepland",
        "origin": "Herkomst",
        "positionShortName": "Pos.",
        "dealerDataNotFound": "Dealergegevens niet gevonden",
        "commission": "Commissie",
        "offer": "Offerte",
        "order": "Order",
        "actions": "Acties",
        "loadMore": "... meer laden",
        "type": "Type",
        "selectType": "Selecteer type",
        "pageNotFound": "Pagina niet gevonden<br /><br />Pad: {path}",
        "mandatoryField": "Verplicht veld",
        "dataStored": "Gegevens opgeslagen",
        "description": "Beschrijving",
        "and": "en",
        "rule": "Regel",
        "units": "Eenheden",
        "lookForValue": "Waarde zoeken",
        "copy": "Kopiëren",
        "share": "Delen",
        "entrance": "Ingang",
        "exit": "Uitgang",
        "reset": "⟳ resetten",
        "apply": "Toepassen",
        "email": "E-mail",
        "phone": "Tel.",
        "duplicate": "Dupliceren",
        "accessKeyCreated": "Toegangssleutel is aangemaakt.",
        "accessKeyDeleted": "Toegangssleutel is verwijderd.",
        "newVersionAvailable": "Er is een nieuwe versie van de software beschikbaar.<br>De pagina wordt herladen.",
        "incompleteInfo": "Nog niet alle<br>informatie is beschikbaar.<br><br>Probeer het later opnieuw."
    }
}